import { PhoneNumberFormat as PNF, PhoneNumberUtil } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();
const formatPhoneNumber = (phoneNumber: string) => {
  try {
    const parsedNumber = phoneUtil.parseAndKeepRawInput(phoneNumber);
    return phoneUtil.format(parsedNumber, PNF.E164);
  } catch (e) {
    return phoneNumber;
  }
};

export default formatPhoneNumber;
